/**
 * Lenis smooth scrolling initialization
 * Provides smooth scrolling for the entire page
 *
 * @package StandOut
 * @since 2.0.0
 */
import Lenis from "lenis";
// Initialize Lenis for smooth scrolling
const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: "vertical",
    smoothWheel: true,
});
// Animation frame loop
function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
}
requestAnimationFrame(raf);
// Make Lenis globally available
globalThis.lenis = lenis;
// Dispatch event for other scripts
const event = new CustomEvent("lenis-ready", { bubbles: true });
window.dispatchEvent(event);
